// views/staff/addStaffLang.js
export const messages = {
    en: {
      addStaff: {
        title: 'Add Staff',
        staffName: 'Staff Name',
        staffNamePlaceholder: 'Required, please enter staff name (2-10 characters)',
        staffPosition: 'Staff Position',
        staffPositionPlaceholder: 'Required, please select position',
        staffGender: 'Staff Gender',
        staffGenderPlaceholder: 'Required, please select gender',
        male: 'Male',
        female: 'Female',
        phone: 'Phone',
        phonePlaceholder: 'Required, please enter phone number',
        photo: 'Photo',
        email: 'Email',
        emailPlaceholder: 'Optional, please enter email',
        address: 'Address',
        addressPlaceholder: 'Required, please enter address',
        relatedOrg: 'Related Organization',
        relatedOrgPlaceholder: 'Required, please select organization',
        save: 'Save',
        cancel: 'Cancel',
        chooseOrg: 'Choose Organization',
        confirm: 'Confirm',
        relCd: 'Relationship',
        relCdPlaceholder: 'Please select relationship'
      }
    },
    zh: {
      addStaff: {
        title: '添加员工',
        staffName: '员工名称',
        staffNamePlaceholder: '必填，请填写员工名称（2-10位）',
        staffPosition: '员工岗位',
        staffPositionPlaceholder: '必填，请选择岗位',
        staffGender: '员工性别',
        staffGenderPlaceholder: '必填，请选择员工性别',
        male: '男',
        female: '女',
        phone: '手机',
        phonePlaceholder: '必填，请填写手机',
        photo: '照片',
        email: '员工邮箱',
        emailPlaceholder: '可选，请填写员工邮箱',
        address: '家庭住址',
        addressPlaceholder: '必填，请填写家庭住址',
        relatedOrg: '关联组织',
        relatedOrgPlaceholder: '必填，请选择关联组织',
        save: '保存',
        cancel: '取消',
        chooseOrg: '选择组织',
        confirm: '确认',
        relCd: '岗位',
        relCdPlaceholder: '请选择岗位'
      }
    }
  }